export default __webpack_public_path__ + "static/media/lynnHTP.cd1525f7.png";